import { mapStrings } from "../../lib/frTypo";

/**
 * "Vrai ou faux" reel — on-screen copy, FR only for now.
 *
 * Every answer is the landing's FAQ (packages/landing/src/i18n/locales/
 * fr.json), shortened:
 *   - followers  → faq.a3 "Frak est pour tout le monde" (+ B2C "Tes proches suffisent.")
 *   - price      → faq.a4 "ils bénéficient également d'un « cash-back »"
 *   - bank       → faq.a1/a2 "transférer… vers ton compte bancaire, sans commission"
 *   - end line   → hero.title "Gagne de l'argent en recommandant ce que tu aimes."
 *   - end sub    → faq.a1 "totalement gratuit" (so "C'est payant ?" isn't a question)
 * Two FAUX then a VRAI: the last answer is the twist. Three questions keep
 * the reel under 15s. B2C house style: tutoiement, no em dashes.
 */
export const QUIZ = mapStrings({
  hook: "Être payé pour tes recos : vrai ou faux ?",
  question: "Question",
  yes: "VRAI",
  no: "FAUX",
  items: [
    {
      claim: "Il faut des milliers d'abonnés.",
      truth: false,
      why: "Tes proches suffisent.",
    },
    {
      claim: "Tes amis paient plus cher via ton lien.",
      truth: false,
      // No-break spaces keep "ils ont du cashback." on one line.
      why: "Au contraire : ils\u00A0ont\u00A0du\u00A0cashback.",
    },
    {
      claim: "Tes gains vont sur ton compte bancaire.",
      truth: true,
      why: "À tout moment, sans commission.",
    },
  ],
  end: {
    line: "Gagne de l'argent en recommandant ce que tu aimes.",
    sub: "Gratuit. Sans abonnés. Du vrai cash.",
  },
});
